import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import get from 'lodash.get';

const TASK_DETAILS_QUERY = gql`
  query getTaskDetails($taskId: String!) {
    task(taskId: $taskId) {
      id
      uri
      displayText
      timeAndExpenseEntryType {
        uri
        displayText
      }
    }
  }
`;

export const useTaskDetails = ({ taskId, skip = false }) => {
  const { data, loading } = useQuery(TASK_DETAILS_QUERY, {
    variables: {
      taskId
    },
    skip,
    fetchPolicy: 'cache-first'
  });

  const task = get(data, 'task', null);

  return {
    task,
    loading
  };
};

export default useTaskDetails;
